'use client';

import Image from "next/image";
import { useRouter } from "next/navigation";

const Logo = () => {
  const router = useRouter();

  return (
    <>
      {/* <Image
        onClick={() => router.push('/')}
        // className="hidden md:block cursor-pointer" 
        className="block cursor-pointer"
        // src="/images/be-underwater-logo-tank.png"
        src="/images/be-underwater-text-3.png"
        height="80" 
        width="80" 
        // height="60"
        // width="60"
        alt="Logo"
      /> */}
       {/* Imagen para dispositivos pequeños */}
       <Image
        onClick={() => router.push('/')}
        className="block md:hidden cursor-pointer"
        src="/images/be-underwater-text-3.png"
        height={120}
        width={120}
        alt="Logo Small"
      />
      {/* Imagen para dispositivos grandes */}
      <Image
        onClick={() => router.push('/')}
        className="hidden md:block cursor-pointer"
        src="/images/be-underwater-logo-7.png"
        height={80}
        width={80}
        alt="Logo Large"
      />
    </>
  );
}

export default Logo;
